module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_color_changer_scene.32030513.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_color_changer_scene.json
// module id = 2237
// module chunks = 0